import GamePushUnity from './GamePushUnity'

window.GamePushUnity = GamePushUnity;
